import type {
  PricingComponents,
  PricingSummary,
} from '@/services/valuation.service';
import { PricingComponentsTable } from '@/pages/loanDetails/ui/PricingComponentsTable';
import { PricingPortfolioSummary } from './PricingPortfolioSummary';

interface PricingTabProps {
  summary: PricingSummary | null;
  pricing: PricingComponents | null;
  currency?: 'USD' | 'EUR' | 'GBP' | 'CAD' | 'AUD';
}

export function PricingTab({ summary, pricing, currency = 'USD' }: PricingTabProps) {
  if (!pricing) {
    return (
      <div
        className="bg-white rounded-lg shadow p-6"
        data-test-id="no-pricing-data"
      >
        <p className="text-gray-600">
          No pricing data available for this loan.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-test-id="pricing-tab">
      <PricingPortfolioSummary summary={summary} currency={currency} />
      <PricingComponentsTable pricingComponents={pricing} currency={currency} />
    </div>
  );
}
